/* COMPONENT - C03.02 Social feed 1.0 */
'use strict';

import twitterFetcher from 'twitter-fetcher';

export default class SocialFeed {
    constructor(element) {
        this.container = element;
        this.entryHolder = this.container.querySelector('.social-feed-entries');
        this.twitterHandle = this.container.querySelector('.social-feed-link').getAttribute('data-twitter-handle');
        this.configProfile = {
            'profile': {
                'screenName': this.twitterHandle
            },
            'maxTweets': 2,
            'enableLinks': false,
            'showUser': true,
            'showTime': false,
            'showImages': false,
            'showInteraction': false,
            'showRetweet': false,
            'dataOnly': true,
            'customCallback': this.renderTweet.bind(this),
            'lang': 'en'
        };
    }

    renderTweet(data) {
        let entries = '';
        for (let i = 0; i < data.length; i++) {
            entries += `<div class='base6 ml12'>
                            <div class='social-feed-entry'>
                                <p class="social-feed-text">${data[i].tweet}</p>
                                <p class="social-feed-tag"><a href="${data[i].permalinkURL}">${this.dateFormatter(data[i].timestamp)}</a></p>
                            </div>
                        </div>`;
        }

        let temp = document.createElement('div');
        temp.innerHTML = entries;
        let entryDivs = temp.querySelectorAll('.social-feed-entry');

        for (let i = 0; i < entryDivs.length; i++) {
            var hashtagLink = entryDivs[i].querySelectorAll('.hashtag');

            for (let j = 0; j < hashtagLink.length; j++) {
                hashtagLink[j].outerHTML = hashtagLink[j].innerText;
            }
        }

        entries = temp.innerHTML;
        this.entryHolder.innerHTML = entries;
    }

    dateFormatter(dateString) {
        const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
          'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];

        let date = new Date(dateString);
        date = `${date.getDate()} ${MONTHS[date.getMonth()]}`;
        return date;
    }

    init() {
        twitterFetcher.fetch(this.configProfile);
    }
}
